import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'

import { AppProvider } from './providers/index.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Rotas from './rotas.js'

import 'react-toastify/dist/ReactToastify.css'
import './style/global.css'

import { createGlobalStyle } from 'styled-components'
import Robson from '../src/components/IA/robson.jsx'

const GlobalStyle = createGlobalStyle`
  .Toastify__toast-container {
    z-index: 999999999 !important;
  }
`

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AppProvider>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      limit={5}
      theme="light"
    />

    <Rotas />
    <GlobalStyle />
  </AppProvider>,
)
